import * as React from 'react';
import classNames from 'classnames';

import * as styles from './index.css';

type TSlide = (visible: boolean) => React.ReactNode;

export interface ISliderProps {
  slides: TSlide[];
}

interface ISliderState {
  currentIndex: number;
  transition: number;
  action: number;
  x0: number;
  stopAutoplay: boolean;
}

export class Slider extends React.PureComponent<ISliderProps, ISliderState> {
  private intervalId: any; // eslint-disable-line @typescript-eslint/no-explicit-any

  public constructor(props: ISliderProps) {
    super(props);

    this.state = {
      action: 0,
      currentIndex: 0,
      transition: 1,
      x0: 0,
      stopAutoplay: false,
    };
  }

  public setSlide(slideIndex: number) {
    this.setState({ currentIndex: slideIndex });
  }

  public transitionEnd = () => {
    const { currentIndex, action } = this.state;

    this.setState({
      action: 0,
      currentIndex: this.validIndex(currentIndex + action),
      transition: 0,
      x0: 0,
    });
  };

  public componentDidMount() {
    this.updateSliding(this.props.slides);
  }

  // TODO выпилить
  // eslint-disable-next-line react/no-deprecated
  public componentWillUpdate(nextProps: ISliderProps) {
    this.updateSliding(nextProps.slides);
  }

  public componentWillUnmount() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  public render() {
    return (
      <div
        onMouseEnter={() => {
          this.setState({ stopAutoplay: true });
        }}
        onMouseLeave={() => {
          this.setState({ stopAutoplay: false });
        }}
        className={styles['container']}
      >
        {this.renderSlides()}
        {this.props.slides.length > 1 && this.renderControls()}
      </div>
    );
  }

  private updateSliding = (slides: TSlide[]) => {
    clearInterval(this.intervalId);

    if (slides.length > 1) {
      this.intervalId = setInterval(this.changeCurrentIndex(1, true), 6000);
    }
  };

  private renderControls = () => {
    const { slides } = this.props;
    const { currentIndex } = this.state;

    return (
      <>
        <div className={styles['arrow-left']}>
          <button className={styles['arrow']} onClick={this.changeCurrentIndex(-1)} />
        </div>
        <div className={styles['arrow-right']}>
          <button className={styles['arrow']} onClick={this.changeCurrentIndex(1)} />
        </div>
        <div className={styles['slide-pagination']}>
          {Array.from(Array(slides.length)).map((value, index) => (
            <div key={index} className={index === currentIndex ? styles['active'] : ''} />
          ))}
        </div>
      </>
    );
  };

  private changeCurrentIndex =
    (action: number, checkAutoplay: boolean = false) =>
    (e?: React.MouseEvent<object>) => {
      if (checkAutoplay && this.state.stopAutoplay) {
        return;
      }

      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      this.step(action);
    };

  private renderSlides = () => {
    const { slides } = this.props;
    const { action, x0, transition } = this.state;
    const transitionX = action ? `${-action * 33.333}%` : `${x0}px`;
    const allSlidesCount = slides.length;
    const leftPseudoSlide = slides.slice(-1)[0];

    return (
      <div
        className={classNames(styles['items'], !!transition && styles['transition'])}
        style={{
          transform: `translateX(${transitionX})`,
          WebkitTransform: `translateX(${transitionX})`,
        }}
        onTransitionEnd={this.transitionEnd}
      >
        {this.getSlide(leftPseudoSlide, 0)}
        {slides.map((slide, index) => this.getSlide(slide, index + 1))}
        {this.getSlide(slides[0], allSlidesCount + 1)}
      </div>
    );
  };

  private validIndex(index: number) {
    const firstIndex = 0;
    const lastIndex = this.props.slides.length - 1;

    if (index < firstIndex) {
      return lastIndex;
    } else if (index > lastIndex) {
      return firstIndex;
    }

    return index;
  }

  private step(action: number) {
    if (this.state.action) {
      this.transitionEnd();
    }

    this.setState({
      action: action ? action : this.state.action,
      transition: 1,
      x0: action ? this.state.x0 : 0,
    });
  }

  private getSlide = (slide: TSlide, index: number) => {
    const { currentIndex } = this.state;
    const relativeIndex = index - currentIndex;
    const visible = relativeIndex >= 0 && relativeIndex <= 2;

    return slide(visible);
  };
}
